// extracted by mini-css-extract-plugin
module.exports = {"container":"FaqSection_container__533Ai","faq":"FaqSection_faq__VNNHY","answer":"FaqSection_answer__7mb_t"};